// extracted by mini-css-extract-plugin
export var columnList = "_c4-0";